// extracted by mini-css-extract-plugin
export default {"panel":"vvJZRYXHa6tCYJQgYQ6j","formItem":"maPexBMhSKAjuOpijAC1","select":"KgAz9IfZEN6jHrgs8UCm","input":"BObxyCXd6xFaOnPab6v7","multiselect":"FpgDtPKTf2CdjE9AcNDa"};